"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.myAccountFooterDefaultItems = exports.myAccountMenuDefaultItems = exports.accountMenuData = void 0;

var Menu_models_1 = require("./Menu.models"); // Represents all possible menu items available


exports.accountMenuData = [Object.freeze({
  id: Menu_models_1.AccountMenuItemId.dashboard,
  icon: Menu_models_1.AccountMenuItemIcon.dashboard,
  label: Menu_models_1.AccountMenuItemLabel.dashboard,
  active: true,
  url: Menu_models_1.AccountMenuItemUrl.dashboard
}), Object.freeze({
  id: Menu_models_1.AccountMenuItemId.orders,
  icon: Menu_models_1.AccountMenuItemIcon.orders,
  label: Menu_models_1.AccountMenuItemLabel.orders,
  active: true,
  url: Menu_models_1.AccountMenuItemUrl.orders
}), Object.freeze({
  id: Menu_models_1.AccountMenuItemId.subscribeSave,
  icon: Menu_models_1.AccountMenuItemIcon.subscribeSave,
  label: Menu_models_1.AccountMenuItemLabel.subscribeSave,
  active: false,
  url: Menu_models_1.AccountMenuItemUrl.subscribeSave
}), Object.freeze({
  id: Menu_models_1.AccountMenuItemId.shoppingList,
  icon: Menu_models_1.AccountMenuItemIcon.shoppingList,
  label: Menu_models_1.AccountMenuItemLabel.shoppingList,
  active: true,
  url: Menu_models_1.AccountMenuItemUrl.shoppingList
}), Object.freeze({
  id: Menu_models_1.AccountMenuItemId.quotes,
  icon: Menu_models_1.AccountMenuItemIcon.quotes,
  label: Menu_models_1.AccountMenuItemLabel.quotes,
  active: true,
  url: Menu_models_1.AccountMenuItemUrl.quotes
}), Object.freeze({
  id: Menu_models_1.AccountMenuItemId.invoices,
  icon: Menu_models_1.AccountMenuItemIcon.invoices,
  label: Menu_models_1.AccountMenuItemLabel.invoices,
  active: true,
  url: Menu_models_1.AccountMenuItemUrl.invoices
}), Object.freeze({
  id: Menu_models_1.AccountMenuItemId.myResources,
  icon: Menu_models_1.AccountMenuItemIcon.myResources,
  label: Menu_models_1.AccountMenuItemLabel.myResources,
  active: false,
  url: Menu_models_1.AccountMenuItemUrl.myResources
}), Object.freeze({
  id: Menu_models_1.AccountMenuItemId.reports,
  icon: Menu_models_1.AccountMenuItemIcon.reports,
  label: Menu_models_1.AccountMenuItemLabel.reports,
  active: true,
  url: Menu_models_1.AccountMenuItemUrl.reports
}), Object.freeze({
  id: Menu_models_1.AccountMenuItemId.documentCenter,
  icon: Menu_models_1.AccountMenuItemIcon.documentCenter,
  label: Menu_models_1.AccountMenuItemLabel.documentCenter,
  active: false,
  url: Menu_models_1.AccountMenuItemUrl.documentCenter
}), // Note: Commented until the functionality is available
// Object.freeze({
// 	id: AccountMenuItemId.claimsReturns,
// 	icon: AccountMenuItemIcon.claimsReturns,
// 	label: AccountMenuItemLabel.claimsReturns,
// 	active: false,
// 	url: AccountMenuItemUrl.claimsReturns
// }),
Object.freeze({
  id: Menu_models_1.AccountMenuItemId.accountSettings,
  icon: Menu_models_1.AccountMenuItemIcon.accountSettings,
  label: Menu_models_1.AccountMenuItemLabel.accountSettings,
  active: true,
  url: Menu_models_1.AccountMenuItemUrl.accountSettings
}), Object.freeze({
  id: Menu_models_1.AccountMenuItemId.userManagement,
  icon: Menu_models_1.AccountMenuItemIcon.userManagement,
  label: Menu_models_1.AccountMenuItemLabel.userManagement,
  active: true,
  url: Menu_models_1.AccountMenuItemUrl.userManagement
}), Object.freeze({
  id: Menu_models_1.AccountMenuItemId.preferenceSettings,
  icon: Menu_models_1.AccountMenuItemIcon.preferenceSettings,
  label: Menu_models_1.AccountMenuItemLabel.preferenceSettings,
  active: false,
  url: Menu_models_1.AccountMenuItemUrl.preferenceSettings
}), Object.freeze({
  id: Menu_models_1.AccountMenuItemId.switchAccounts,
  icon: Menu_models_1.AccountMenuItemIcon.switchAccounts,
  label: Menu_models_1.AccountMenuItemLabel.switchAccounts,
  active: true,
  url: Menu_models_1.AccountMenuItemUrl.switchAccounts
}), Object.freeze({
  id: Menu_models_1.AccountMenuItemId.logOut,
  icon: Menu_models_1.AccountMenuItemIcon.logOut,
  label: Menu_models_1.AccountMenuItemLabel.logOut,
  active: true,
  url: Menu_models_1.AccountMenuItemUrl.logOut
}), Object.freeze({
  id: Menu_models_1.AccountMenuItemId.documentCenter,
  icon: Menu_models_1.AccountMenuItemIcon.documentCenter,
  label: Menu_models_1.AccountMenuItemLabel.documentCenter,
  active: false,
  url: Menu_models_1.AccountMenuItemUrl.documentCenter
}), Object.freeze({
  id: Menu_models_1.AccountMenuItemId.creditApplication,
  icon: Menu_models_1.AccountMenuItemIcon.creditApplication,
  label: Menu_models_1.AccountMenuItemLabel.creditApplication,
  active: true,
  url: Menu_models_1.AccountMenuItemUrl.creditApplication
}), Object.freeze({
  id: Menu_models_1.AccountMenuItemId.adminPortal,
  icon: Menu_models_1.AccountMenuItemIcon.adminPortal,
  label: Menu_models_1.AccountMenuItemLabel.adminPortal,
  active: true,
  url: Menu_models_1.AccountMenuItemUrl.adminPortal
}), Object.freeze({
  id: Menu_models_1.AccountMenuItemId.exitShadowMode,
  icon: Menu_models_1.AccountMenuItemIcon.exitShadowMode,
  label: Menu_models_1.AccountMenuItemLabel.exitShadowMode,
  active: true,
  url: Menu_models_1.AccountMenuItemUrl.exitShadowMode
})]; // The Drives the MyAccount Menu and Footer CustomerPortal

exports.myAccountMenuDefaultItems = [Menu_models_1.AccountMenuItemId.dashboard, Menu_models_1.AccountMenuItemId.orders, Menu_models_1.AccountMenuItemId.shoppingList, Menu_models_1.AccountMenuItemId.quotes, Menu_models_1.AccountMenuItemId.invoices, Menu_models_1.AccountMenuItemId.reports, Menu_models_1.AccountMenuItemId.accountSettings, Menu_models_1.AccountMenuItemId.userManagement];
exports.myAccountFooterDefaultItems = [Menu_models_1.AccountMenuItemId.switchAccounts, Menu_models_1.AccountMenuItemId.adminPortal, Menu_models_1.AccountMenuItemId.exitShadowMode, Menu_models_1.AccountMenuItemId.logOut];